import { CmsImage } from "../content/cms-image";
import { Slideshow as BaseSlideshow } from "../content/slideshow";
import {
  Children,
  isValidElement,
  PropsWithChildren,
  ReactElement,
} from "react";
import { SlideProps } from "../content/slide";

export const Slideshow = ({ children }: PropsWithChildren) => {
  const slides = Children.toArray(children)
    .filter(
      (child): child is ReactElement<SlideProps> =>
        isValidElement(child) && typeof child.type !== "string",
    )
    .map((child: ReactElement<SlideProps>) => {
      const { title, description, image } = child.props;
      return {
        title,
        description,
        image: <CmsImage image={image} alt={title} />,
      };
    });

  return <BaseSlideshow slides={slides} />;
};
